module.exports = __webpack_public_path__ + "img/expiring-soon.abc105d7.svg";